<template>
  <div class="product">
    <header id="header" class="animate__animated animate__zoomIn animate__slow">
      <img src="../assets/images/product.jpg" alt="">
    </header><!-- /header -->

    <!-- 内容部分 -->
    <article class="introduce-con">
      <nav class="col-md-3 animate__animated animate__wobble animate__slow">
        <div>
          <h4>产品中心</h4>
          <hr class="hrs" />
          <p class="engsh">PRODUCT</p>
        </div>

        <ul class="introduce-nav animate__animated animate__wobble animate__slow">
          <li :class="{'active':tabIndex==1}" @click="tabOptions(1,true)"><a>电商设备</a></li>
          <hr class="hrs" />
          <li :class="{'active':tabIndex==2}" @click="tabOptions(2,true)"><a>物流设备</a></li>
          <hr class="hrs" />
          <li :class="{'active':tabIndex==3}" @click="tabOptions(3,true)"><a>仓储设备</a></li>
          <!-- <hr class="hrs" /> -->
        </ul>
      </nav>
      <aside class="col-md-9 ">
        <div class="col-md-12 animate__animated animate__bounceInDown ">
          <h4 class="col-md-4 text-left">{{tabName}}</h4>
          <div class="col-md-8 text-right">
            <p>当前位置：首页 > 产品中心 > <span>{{tabName}}</span></p>
          </div>

          <div class="line"></div>
        </div>
        <!-- 电商设备 -->
        <div class="col-md-12 text-content animate__animated  animate__bounceInUp animate__slow">
          <div v-if="tabIndex==1">
            <commerce-equipment v-bind:indexs.sync="detailIndex"></commerce-equipment>
          </div>
        </div>

      </aside>
    </article>

  </div>
</template>

<script>
import commerceEquipment from "./product/commerceEquipment.vue";
export default {
  name: "Product",
  data() {
    return {
      tabIndex: 1,
      tabName: "电商设备",
      detailIndex: true,
    };
  },
  computed: {},
  components: {
    commerceEquipment: commerceEquipment,
  },

  methods: {
    tabOptions(index, item) {
      // alert(this.detailIndex)
      this.tabIndex = index;
      if (index == 1) {
        this.tabName = "电商设备";
        this.detailIndex = item;
      } else if (index == 2) {
        this.tabName = "物流设备";
      } else {
        this.tabName = "仓储设备";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product {
  min-height: 670px;
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
  text-decoration: none;
  color: #333;
  cursor: pointer;
}
/* 头部斑点图 */
#header img {
  width: 100%;
  height: 150px;
}

/*内容部分*/
.line {
  width: 97%;
  height: 1px;
  background-color: #ededed;
  display: block;
  margin-top: 46px;
}
.hrs {
  width: 80%;
  margin: 0 auto;
  height: 1px;
  border: 0;
  margin-bottom: 4px;
}
.introduce-con {
  width: 60%;
  margin: 20px auto;
  background: #ffffff;
}
.introduce-con nav {
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  position: relative;
  top: -80px;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
}
.engsh {
  /*margin-left: 20px;*/
}
.introduce-con nav ul {
  line-height: 40px;
}
.introduce-con nav div {
  background: #162987;
  color: #ffffff;
  text-align: left;
  padding: 10px 0;
}

.introduce-con nav div h4,
p {
  margin-left: 10%;
}
.introduce-con nav div hr {
  background-color: #2b3f96;
}
.introduce-nav hr {
  background-color: #ededed;
}
.introduce-nav .active a {
  color: #162987;
}

/*内容*/
.text-left {
  padding: 0;
  margin-bottom: 20px;
  vertical-align: middle;
  padding-left: 2px;
  text-align: left;
}
.text-right p {
  text-align: right;
  margin-top: 12px;
  padding: 0;
  padding-bottom: 30px;
  font-size: 12px;
  color: #b7b7b7;
}
.text-right p span {
  color: #414141;
}
/*电商设备的模板*/
.text-content {
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue